import { render, staticRenderFns } from "./OrderCancelled.vue?vue&type=template&id=45c52612&lang=html"
import script from "./OrderCancelled.vue?vue&type=script&lang=js"
export * from "./OrderCancelled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports